import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['submit'];

  initialize() {
    this.checkField = this.checkField.bind(this);
  }

  get inputs() {
    return Array.from(this.element.querySelectorAll('input')).filter((field) => field.required);
  }

  connect() {
    this.inputs.forEach((field) => {
      field.addEventListener('change', this.checkField);
      field.addEventListener('keyup', this.checkField);
      field.addEventListener('keydown', this.checkField);
    });
  }

  disconnect() {
    this.inputs.forEach((field) => {
      field.removeEventListener('change', this.checkField);
      field.removeEventListener('keyup', this.checkField);
      field.removeEventListener('keydown', this.checkField);
    });
  }

  checkField() {
    const anyEmptyRequiredFields = this.inputs.some((field) => field.value === '');
    this.submitTarget.disabled = anyEmptyRequiredFields;
  }
}
